import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { RootState, closeCallMeModal, closeContactModal, useAppDispatch, useAppSelector } from 'src/common';
import { CallMeModal, ContactModal, Content, Footer, Header, Message } from 'src/components';


const AppRouter = () => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();

  const callMeModalOpen = useAppSelector((store: RootState) => store.state.modal.callMeModal.open);
  const contactModalOpen = useAppSelector((store: RootState) => store.state.modal.contactModal.open);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <Header />
      <Content>
        <Message />
        <Outlet />
      </Content>
      <Footer />

      <CallMeModal open={callMeModalOpen} onClose={() => dispatch(closeCallMeModal())} />
      <ContactModal open={contactModalOpen} onClose={() => dispatch(closeContactModal())} />
    </>
  )
};

export default AppRouter;